import { AppRouterInstance } from 'next/dist/shared/lib/app-router-context.shared-runtime';
import { Maybe, UsAePayErrorMessage } from '~/gql/__generated__/types';
import revalidateCache from '~/utils/revalidate-cache';

export function paymentErrorRedirect(
  errorCode: string,
  orderId: string,
  router?: AppRouterInstance,
  usaEPayErrorMessages?: Maybe<Maybe<UsAePayErrorMessage>[]> | undefined,
) {
  // Check if the error code should be excluded based on the config
  const shouldExcludeError = usaEPayErrorMessages?.some(
    (item) => item?.errorCode === errorCode?.trim() && item?.exclude,
  );

  // If the error should be excluded, redirect without error parameter
  const errString = shouldExcludeError
    ? `/makeapayment?orderId=${orderId}`
    : `/makeapayment?orderId=${orderId}&error=${errorCode}`;

  if (
    typeof window !== 'undefined' &&
    window.history &&
    'pushState' in window.history
  ) {
    window.history.pushState(null, '', errString);
  } else if (router) {
    try {
      router.push(errString);
    } catch (error) {
      console.error('Failed to redirect:', error);
    }
  }
  revalidateCache().then(() => {
    if (router) {
      router.refresh();
    }
  });
}
